export default function PrimaryButton(props) {
  const disabledCSS = props.disabled ? "text-gray-400 cursor-not-allowed" : "text-white";
  return (
    <button
      {...props}
      type="button"
      className={`${disabledCSS} rounded-md bg-blue-600 px-3 py-2.5 font-semibold  shadow-xs hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 ${props.className}`}
    >
      {props.label}
    </button>
  );
}
